import React, { memo, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAlert } from "react-alert";
import { Link, useNavigate } from "react-router-dom";
import UpperHeader from "./UpperHeader";
import Header from "./Header";
import Report from "./Report";
import Footer from "./Footer";

export default function ResultSearch() {
    let alert = useAlert();
    const [searchParams] = useSearchParams();
    const [result, setresult] = useState([]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_URL_API}/data/searchresult`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({
                keyword: searchParams.get("keyword"),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setresult(data)
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al buscar, por favor intenta de nuevo " +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }, [searchParams]);

    const TypeSearch = ({ type }) => {
        var returndata;

        switch (type.typesearch) {
            case "news":
                return <>
                    <h3>Noticia</h3>
                    <Link to={`/newsdetail/${type.uuid}`} className='noLink newsCenter' >{type.textsearch}</Link>
                </>
            case "normativa":
                return <>
                    <h3>Normativa {type.typerubro}</h3>
                    <Link to={`/normativa`} className='noLink newsCenter' >{type.textsearch}</Link>
                </>
            case "estradoelectro":
                return <>
                    <h3>Estrado Electronico</h3>
                    <Link to={`/boards`} className='noLink newsCenter' >{type.textsearch}</Link>
                </>
            case "declaration":
                return <>
                    <h3>DeclaraNET</h3>
                    <Link to={`/declaranet`} className='noLink newsCenter' >Ir a Declaranet</Link>
                </>
            case "aboutus":
                return <>
                    <h3>Sobre Nosotros</h3>
                    <Link to={`/aboutus`} className='noLink newsCenter' >Ir a Sobre Nosotros</Link>
                </>

            default:
                return <></>
        }
    }

    return (
        <>
            <UpperHeader child={false} />
            <Header />
            <Report />
            <div className="container bg-light pt-3 allHeightWH pb-4">
                {result.length == 0 ? (
                    <div>
                        <h1 className="text-center">
                            No se encontró ningún resultado con la busqueda "
                            {searchParams.get("keyword")}"
                        </h1>
                    </div>
                ) : (
                    <div>
                        <h1 className="text-center">
                            Resultado de la busqueda "{searchParams.get("keyword")}"
                        </h1>
                        <hr />
                        <div className="dgrid d-grid">
                            {result.map((data, i) => {
                                return (
                                    <TypeSearch type={data} />
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
            <Footer showmap={false} />
        </>
    )
}
